export default [
  {
    title: 'زائرکارت',
    icon: 'bx bx-credit-card',
    children: [
      {
        title: 'درخواست‌ها',
        route: { name: 'zaercard' },
        resource: 'ZaerCardManager',
        action: 'show',
      },
    ],
  },
]
